import React from 'react';

export default function TrademarkNotice() {
  return (
    <div className="bg-white min-h-screen py-12 px-4">
      <div className="max-w-4xl mx-auto text-gray-800 space-y-8">
        <h1 id="trademark-notice" className="text-3xl text-center font-bold text-purple-600 mb-6">® Trademark Notice</h1>

        <p>
          The names <strong>Million2Trillion</strong>, <strong>M2T Technologies</strong>, and the <strong>M2T</strong> logo are trademarks or
          registered trademarks of M2T Global Technologies, including any associated taglines, icons, or design elements.
        </p>

        <p>
          Unauthorized use of these marks in connection with any product, service, website, or brand that does not belong
          to the official Million2Trillion platform may violate trademark law and result in legal action.
        </p>

        <h2 className="text-xl font-semibold text-purple-500 mt-8 mb-3">Fair Use Guidelines</h2>
        <p>
          You may refer to Million2Trillion or M2T Technologies in descriptive contexts (such as news, reviews, or
          educational commentary), provided that:
        </p>
        <ul className="list-disc list-inside mb-4 space-y-2 text-gray-700">
          <li>You do not misrepresent affiliation or sponsorship.</li>
          <li>You do not modify or distort the brand identity or logo.</li>
          <li>You clearly attribute any quoted or referenced material.</li>
        </ul>

        <h2 className="text-xl font-semibold text-purple-500 mt-8 mb-3">Logo Usage</h2>
        <p>
          If you wish to use the Million2Trillion logo or M2T branding in media, partnerships, or sponsored materials,
          you must obtain prior written approval. Please contact our support team for licensing or permission requests.
        </p>

        <p className="mt-8 text-sm text-gray-400">
          Last updated: June 2025
        </p>
      </div>
    </div>
  );
}
